module.exports = __webpack_public_path__ + "static/media/transfer_player.994f3233.svg";